import { mutatorAction } from "satcheljs";
import type { ScrollableSubjectHeaderViewState } from "../store/schema/SubjectHeaderViewState";

export const setContentReadyMutator: (viewState: ScrollableSubjectHeaderViewState, context: string, isReady: boolean) => void = mutatorAction("setContentReadyMutator", function (viewState: ScrollableSubjectHeaderViewState, context: string, isReady: boolean): void {
    if (!viewState.isContentReady) {
        viewState.isContentReady = new Map<string, boolean>();
    }
    viewState.isContentReady.set(context, isReady);
});
